import React, { useEffect, useState, useRef } from "react";
import styles from "./DownloadTheApplicationFinish.module.css";
import { DownloadSvg } from "../../img/Image";
import { GooglePlaySvg, AppStoreSvg } from "../../img/ImageQr";

const DownloadTheApplicationFinish = ({ forHeader = false, isMobileVersion = false, onClose }) => {
    const [isModalOpen, setIsModalOpen] = useState(true); // Модальное окно открыто по умолчанию
    const [isMobile, setIsMobile] = useState(false);
    const [isIOS, setIsIOS] = useState(false);
    const [isAndroid, setIsAndroid] = useState(false);

    useEffect(() => {
        // Определяем тип устройства
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        setIsMobile(/android|iPad|iPhone|iPod/i.test(userAgent));
        setIsIOS(/iPad|iPhone|iPod/i.test(userAgent));
        setIsAndroid(/android/i.test(userAgent));
    }, []);

    const closeModal = () => {
        setIsModalOpen(false);
        if (onClose) onClose();
    };

    const modalRef = useRef(null);
    const [isAnimating, setIsAnimating] = useState(false);

    const closeModalWithAnimation = () => {
        setIsAnimating(false);
        setTimeout(() => {
            closeModal();
        }, 200);
    };

    useEffect(() => {
        if (isModalOpen) {
            setIsAnimating(true);
        }
    }, [isModalOpen]);

    return (
        <>
            {isModalOpen && (
                <div className={`${styles.modalOverlay} ${isAnimating ? styles.modalOverlayVisible : ''}`}
                    onClick={closeModalWithAnimation}
                >
                    <div
                        ref={modalRef}
                        className={`${styles.modalProfile} ${isAnimating ? styles.modalVisible : ''}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className={styles.modalHeaderProfile} style={{ padding: "20px 20px 0px 20px" }}>
                            <button
                                onClick={closeModalWithAnimation}
                                className={styles.backButton}
                                aria-label="Вернуться назад"
                            >
                              
                            </button>
                            <button
                                onClick={closeModalWithAnimation}
                                className={styles.modalCloseButtonProfile}
                                aria-label="Закрыть"
                            >
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="#000" strokeWidth="2" fill="none">
                                    <path d="M6 6L18 18" />
                                    <path d="M6 18L18 6" />
                                </svg>
                            </button>
                        </div>

                        <div className={styles.modalBody} style={{ padding: "20px" }}>
                            {/* Контент для мобильных устройств */}
                            {isMobile ? (
                                <div className={styles.mobileContent}>
                                    <div className={styles.successMessage}>
                                        Поздравляем, ваша заявка на участие в мероприятие была успешно отправлена! 
                                        Отслеживать статус заявки можете в мобильном приложении, либо на вкладке Мои заявки
                                    </div>
                                    <button
                                        className={styles.downloadAppButton}
                                        onClick={() => {
                                            if (isIOS) {
                                                window.open('https://apps.apple.com/ru/app/1%D1%81-%D1%80%D0%B0%D1%80%D1%83%D1%81-%D0%BC%D0%B5%D1%80%D0%BE%D0%BF%D1%80%D0%B8%D1%8F%D1%82%D0%B8%D0%B5/id1444723437?l=en-GB', '_blank');
                                            } else if (isAndroid) {
                                                window.open('https://play.google.com/store/apps/details?id=com.rarus.events&hl=ru', '_blank');
                                            }
                                        }}
                                    >
                                        Скачать мобильное приложение
                                    </button>
                                </div>
                            ) : (
                                /* Контент для компьютеров */
                                <div className={styles.desktopContent}>
                                    <div className={styles.successMessage}>
                                        Поздравляем, ваша заявка на участие в мероприятие была успешно отправлена! 
                                        Отслеживать статус заявки можете в мобильном приложении, либо на вкладке Мои заявки
                                    </div>
                                    <div className={styles.qrContainer}>
                                        <div className={styles.qrBlock}>
                                            <GooglePlaySvg className={styles.qrImage} />
                                            <button
                                                className={styles.storeButton}
                                                onClick={() => window.open('https://play.google.com/store/apps/details?id=com.rarus.events&hl=ru', '_blank')}
                                            >
                                                Google Play
                                            </button>
                                        </div>
                                        <div className={styles.qrBlock}>
                                            <AppStoreSvg className={styles.qrImage} />
                                            <button
                                                className={styles.storeButton}
                                                onClick={() => window.open('https://apps.apple.com/ru/app/1%D1%81-%D1%80%D0%B0%D1%80%D1%83%D1%81-%D0%BC%D0%B5%D1%80%D0%BE%D0%BF%D1%80%D0%B8%D1%8F%D1%82%D0%B8%D0%B5/id1444723437?l=en-GB', '_blank')}
                                            >
                                                App Store
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default DownloadTheApplicationFinish;